/*
Prakash 01/11/2022 2698811066 added background-color for accordion.
Prakash 11/02/2022 2698811066 Added styling spacing  for Fields.
Asharf 12/28/2022 2698811066 Added doc upload widget
Asharf 12/29/2022 2698811066 changed upload icon for upload document
suresh peddavoora 03/08/2023 2698811066 right side-bar alignments
Prakash 03/07/2023 2698811066 Added conditions classname.

*/
import React, {useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import WidgetsIcon from '@material-ui/icons/Widgets';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import Add2 from './AddWidgeDialog';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import Calculator from '../../../components/Calculator/Calculator';
import Tooltip from '@material-ui/core/Tooltip';
import TelegramIcon from '@material-ui/icons/Telegram';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import NoteAddOutlinedIcon from '@material-ui/icons/NoteAddOutlined';
import {useSelector} from 'react-redux';
import PublishIcon from '@material-ui/icons/Publish';
import TimerIcon from '@material-ui/icons/Timer';
import CalcIcon from '../../../assets/images/calculatorIcon.svg';
// import AddaNoteW8 from "../../GalaxyCoreWindows/AddaNote/AddaNotes";
import AddaNote from '../../../components/AddaNotes';
import ScanForm from '../../GalaxyCoreWindows/DocumentsManagement/ScanForm';
import {SPLIT_SCREEN} from '../../../constants/WorkQueueConstants';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'marginBottom': '10px',
    // backgroundColor: "#EBEBEB",
    'boxShadow': '0px 4px 4px #0000000a',
    'opacity': 1,
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      borderRadius: 6,
    },
    '& .MuiCollapse-wrapper': {
      backgroundColor: '#c9c9c9',
      boxShadow: '0 4px 4px rgb(0 0 0 / 4%)',
      opacity: 1,
      padding: '.625rem .3125rem',
      marginBottom: '.9375rem',
    },
    // '& .Mui-expanded': {
    //   margin: '12px 0px 5px',
    // },
  },
  accordionDetailsStyling: {
    'backgroundColor': '#ffffff',
    'padding': '8px 0px 0px 0px',
    'borderRadius': '8px',
    // boxShadow:
    //   "0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)",
    '&.MuiGrid-spacing-xs-2': {
      margin: '0px -5px !important',
    },
    '& .MuiGrid-spacing-xs-2 ': {
      '& .MuiGrid-item': {
        padding: '0px 10px !important',
      },
    },
    '& .form-row': {
      '& .col': {
        paddingRight: '10px !important',
        paddingLeft: '10px !important',
      },
      '& [class*=col-]': {
        paddingRight: '10px !important',
        paddingLeft: '10px !important',
      },
    },
  },

  heading: {
    // fontSize: theme.typography.pxToRem(16),
    fontSize: '0.7825rem !important',
    fontWeight: 600,
    flexShrink: 0,
    marginTop: 0,
    marginLeft: 4,
  },
  workSummaryHeading: {
    color: '#5351fb',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
    },
  },
  tableDetails: {
    padding: '2px !important',
    backgroundColor: '#f4f9fa',
    border: '1px solid #f4f9fa',
    borderRadius: '8px',
  },
  detailsCard: {
    padding: '10px 0',
    fontSize: '.75rem',
    color: '#000',
    fontWeight: 400,
    lineHeight: '1.25rem',
    fontFamily: 'Roboto,sans-serif',
  },
  windowsCard: {
    padding: '10px 20px',
    fontSize: '.75rem',
    color: '#000',
    fontWeight: 400,
    lineHeight: '1.25rem',
  },
  calculatorDetails: {
    padding: '0',
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },
  uploadDocument: {
    display: 'block',
    whiteSpace: 'normal !important',
    borderRadius: 6,
  },
  telegramIcon: {
    '& .MuiSvgIcon-root': {
      fontSize: '22px',
      marginTop: '-2px',
    },
  },
  timerIcon: {
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      marginTop: '-3px',
      marginRight: '6px',
    },
  },
  messageIcon: {
    '& .MuiSvgIcon-root': {
      marginRight: '7px',
      fontSize: '24px',
    },
  },
  tabIcon: {
    '& .MuiSvgIcon-root': {
      marginRight: '7px',
      marginTop: '-3px',
      fontSize: '24px',
    },
  },
  calculator: {
    backgroundColor: '#EBEBEB',
    // boxShadow: "0px 3px 3px #0000000a",
    opacity: 1,
    borderRadius: '8px 8px 0px 0px;',
    color: '#222',
  },
}));
export default function SidePanel() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [sidePanelNotes, setSidePanelNotes] = useState(false);

  const {
    setSelectedTabs,
    selectedTabs,
    setCommunication,
    setLabel,
    setOnChipClick,
    setCurrentLabel,
    label,
  } = useContext(SelectTabContextProvider);
  const transcription = '';
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const {showDashboardWorkQueue} = useSelector(({role}) => role);
  const handleChange = (panel) => {
    setExpanded(!expanded);
  };
  const handleCommunication = (type) => {
    setOnChipClick(true);
    setCurrentLabel('W52,W95');
    const values = {label: 'Communication History (W52, W95)', code: 'W52,W95'};
    if (!label.includes('W52,W95')) {
      setLabel([...label, 'W52,W95']);
      setSelectedTabs([...selectedTabs, values]);
      setCommunication(type);
    } else if (label.includes('W52,W95')) {
      setCommunication(type);
    }
  };
  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };
  return (
    <div
      className={`  ${
          SPLIT_SCREEN.ARRAY_VALUES.includes(showDashboardWorkQueue) &&
          location.pathname === `/account-summary` ?
            ' widget-card card-box' :
            'widget-block widget-card card-box'
      } `} >
      <div className="widget-section widget-scroller">
        <div className="row">
          <Add2 open={open} handleModalClose={handleCloseDialog} />
          <div className="col-lg-12 mt-3">
            <div className={classes.root}>
              <Accordion
                className="accordion-styling work-summary"
                elevation={0}
                // expanded={expanded}
                // expanded={expanded === "panel1"}
                // onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  onClick={() => handleChange()}
                  className={classes.calculator}
                  expandIcon={<ExpandMoreIcon />}
                  id="panel2bh-header"
                >
                  <TimerIcon />
                  <Typography
                    onClick={() => handleCommunication('Summary')}
                    className={clsx(classes.heading, classes.workSummaryHeading)}
                  >
                    Work and Communication Summary
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  className={classes.tableDetails}
                  actions={
                    <span className="morevertIcon">
                      <MoreVertIcon />
                    </span>
                  }
                >
                  <table>
                    <tbody>
                      <tr className="timesheet text-center">
                        <th colSpan="5">Time Spent: 20</th>
                        {/* <th colspan="3">: 20</th> */}
                        {/* <th></th> */}
                      </tr>
                      <tr className="timesheet text-center">
                        <th colSpan="5">Worked Hours: 10</th>
                        {/* <th colspan="2">Worked Hours</th>
                    <th colspan="3">: 10</th>
                    <th></th> */}
                      </tr>
                      <tr>
                        <th></th>
                        <th className="text-center">
                          <Tooltip title="Sent">
                            <span className={classes.telegramIcon}>
                              <TelegramIcon />
                            </span>
                          </Tooltip>
                        </th>
                        <th className="text-center">
                          <Tooltip title="Received">
                            <span className={classes.telegramIcon}>
                              <CallReceivedIcon />
                            </span>
                          </Tooltip>
                        </th>
                        <th className="text-center">
                          <Tooltip title="Returned">
                            <span className={classes.telegramIcon}>
                              <RotateLeftIcon />
                            </span>
                          </Tooltip>
                        </th>

                        <th className="text-center">
                          <Tooltip title="CTA">
                            <span className={classes.telegramIcon}>
                              <TouchAppIcon />
                            </span>
                          </Tooltip>
                        </th>
                      </tr>
                      <tr>
                        <th>Phone call</th>
                        <td className="success" onClick={() => handleCommunication('Phone Calls')}>
                          2
                        </td>
                        <td onClick={() => handleCommunication('Phone Calls')}>2</td>
                        <td
                          className="un-success"
                          onClick={() => handleCommunication('Phone Calls')}
                        >
                          0
                        </td>
                        <td className="cta-na">NA</td>
                      </tr>
                      <tr>
                        <th>Letter</th>
                        <td
                          className="success"
                          onClick={() => handleCommunication('Letter History')}
                        >
                          1
                        </td>
                        <td onClick={() => handleCommunication('Letter History')}>0</td>
                        <td
                          className="un-success"
                          onClick={() => handleCommunication('Letter History')}
                        >
                          1
                        </td>
                        <td className="cta-na">NA</td>
                      </tr>
                      <tr>
                        <th>Email</th>
                        <td className="success" onClick={() => handleCommunication('Email')}>
                          1
                        </td>
                        <td onClick={() => handleCommunication('Email')}>1</td>
                        <td className="un-success" onClick={() => handleCommunication('Email')}>
                          0
                        </td>
                        <td onClick={() => handleCommunication('Email')}>0</td>
                      </tr>
                      <tr>
                        <th>Voapps</th>
                        <td className="success" onClick={() => handleCommunication('Voapps')}>
                          1
                        </td>
                        <td onClick={() => handleCommunication('Voapps')}>1</td>
                        <td className="un-success" onClick={() => handleCommunication('Voapps')}>
                          0
                        </td>
                        <td onClick={() => handleCommunication('Voapps')} className="cta-na">
                          NA
                        </td>
                      </tr>
                      <tr>
                        <th>Text</th>
                        <td className="success" onClick={() => handleCommunication('Text History')}>
                          1
                        </td>
                        <td onClick={() => handleCommunication('Text History')}>1</td>
                        <td
                          className="un-success"
                          onClick={() => handleCommunication('Text History')}
                        >
                          1
                        </td>
                        <td onClick={() => handleCommunication('Text History')}>1</td>
                      </tr>
                      <tr>
                        <th>Other correspondence</th>
                        <td className="success">0</td>
                        <td>0</td>
                        <td className="un-success">0</td>
                        <td className="cta-na">NA</td>
                      </tr>
                      <tr className="total-history">
                        <th>Total</th>
                        <td className="cta-na">6</td>
                        <td className="cta-na">5</td>
                        <td className="cta-na">1</td>
                        <td className="cta-na">1</td>
                      </tr>
                    </tbody>
                  </table>
                </AccordionDetails>
              </Accordion>
            </div>

            <div className={classes.root}>
              <Accordion className="accordion-styling message-board" elevation={0}>
                <AccordionSummary
                  className={classes.calculator}
                  expandIcon={<ExpandMoreIcon />}
                  id="panel2bh-header"
                  onClick={() => setSidePanelNotes(true)}
                >
                  <NoteAddOutlinedIcon />
                  <Typography className={classes.heading}>Add a Note</Typography>
                </AccordionSummary>
                <AccordionDetails
                  className={classes.detailsCard}
                  actions={
                    <span>
                      <MoreVertIcon />
                    </span>
                  }
                >
                  <AddaNote
                    transcription={transcription}
                    charLimitMsg={charLimitMsg}
                    setCharLimitMsg={setCharLimitMsg}
                    sidePanelNotes={sidePanelNotes}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
            <div className={classes.root}>
              <Accordion className="accordion-styling message-board" elevation={0}>
                <AccordionSummary
                  className={classes.calculator}
                  expandIcon={<ExpandMoreIcon />}
                  id="panel2bh-header"
                >
                  <PublishIcon />
                  <Typography className={classes.heading}>Upload Document</Typography>
                </AccordionSummary>
                <AccordionDetails
                  className={`${classes.detailsCard} ${classes.uploadDocument}`}
                  actions={
                    <span>
                      <MoreVertIcon />
                    </span>
                  }
                >
                  <ScanForm sideBarScan={true} />
                </AccordionDetails>
              </Accordion>
            </div>
            {/* <div className={classes.root}>
              <Accordion
                className="accordion-styling message-board"
                elevation={0}
                // expanded={expanded === "panel2"}
                // onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  className={classes.calculator}
                  expandIcon={<ExpandMoreIcon />}
                  id="panel2bh-header"
                >
                  <MessageOutlinedIcon />
                  <Typography className={classes.heading}>
                    Message Board
                    <span className="message-count">(2)</span>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  className={classes.detailsCard}
                  // header={
                  //   <span className={classes.messageIcon}>
                  //     <MessageIcon />
                  //     Message Board <span className="message-count">(2)</span>
                  //   </span>
                  // }
                  actions={
                    <span>
                      <MoreVertIcon />
                    </span>
                  }
                >
                  <ul>
                    <li>
                      Happy to Announce!! <br />
                      Initiating Digital Transformation of PDS Galaxy.
                      <div className="message-author">
                        <p>1 day ago</p>
                      </div>
                    </li>
                    <li>
                      Happy Birthday John Doe!.
                      <div className="message-author1">
                        <p>23m ago</p>
                      </div>
                    </li>
                  </ul>
                  <div className="enter-btn">
                    <input type="text" placeholder="Type and enter" />
                    <button className="submit-btn">
                      submit
                      <ChevronRightIcon />
                    </button>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div> */}

            <div className={classes.root}>
              <Accordion
                // expanded={expanded === "panel3"}
                // onChange={handleChange("panel3")}
                className="accordion-styling calculator calculate"
                elevation={0}
                // expanded={expanded === "panel3"}
                // onChange={handleChange("panel3")}
              >
                <AccordionSummary
                  className={classes.calculator}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <img
                    className="calc-img"
                    style={{
                      width: '18px',
                    }}
                    src={CalcIcon}
                    alt="CalcImage"
                  />
                  <Typography className={classes.heading}>Calculator</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.calculatorDetails}>
                  <Calculator />
                </AccordionDetails>
              </Accordion>
            </div>
            {/* <div className={classes.root}>
            <Accordion
              className="accordion-styling account-tab"
              elevation={0}
              // expanded={expanded === "panel4"}
              // onChange={handleChange("panel4")}
            >
              <AccordionSummary
                className={`account-tabs ${classes.calculator}`}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <TabIcon />
                <Typography className={classes.heading}>Account Tabs</Typography>
              </AccordionSummary>
              <AccordionDetails
                className={`custom-windows custom-windows-scroller ${classes.windowsCard}`}
                actions={
                  <div className="custom-tab-action">
                    <span>
                      <MoreVertIcon />
                    </span>
                  </div>
                }
              >
                <CmtSearch
                  onlyIcon
                  onChange={onSearchQuery}
                  className="custom-tab-search"
                  border={false}
                />
                {windows}
              </AccordionDetails>
            </Accordion>
            </div> */}
          </div>
        </div>
        <div className="new-widget-sec">
          <span onClick={handleOpenDialog}>
            <WidgetsIcon className="widget-icon" />
            Add New Widget
          </span>
        </div>
      </div>
    </div>
  );
}
